document.querySelectorAll('.js_show_cookie_banner').forEach((elem) => {
  elem.addEventListener('click', (e) => {
    privacyBanner.showPreferences();
  });
});

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'granted',
  personalization_storage: 'denied',
  security_storage: 'granted',
});

const scripts = [...document.scripts].filter((elem) => elem.dataset.hasOwnProperty('consent'));

function loadScripts(consent) {
  scripts.forEach((script) => {
    if (consent[script.dataset.consent] && script.type != 'text/javascript') {
      script.type = 'text/javascript';
      document.head.appendChild(script);
    }
  });
  gtag('consent', 'update', {
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied',
    analytics_storage: consent.analytics ? 'granted' : 'denied',
    functionality_storage: 'granted',
    personalization_storage: consent.preferences ? 'granted' : 'denied',
    security_storage: 'granted',
  });
  window.dataLayer.push({ event: 'visitorConsentCollected' });
}

document.addEventListener('load', (e) => {
  loadScripts({
    analytics: window.Shopify.customerPrivacy.analyticsProcessingAllowed(),
    marketing: window.Shopify.customerPrivacy.marketingAllowed(),
    preferences: window.Shopify.customerPrivacy.preferencesProcessingAllowed(),
    saleOfData: window.Shopify.customerPrivacy.saleOfDataAllowed(),
  });
});

document.addEventListener('visitorConsentCollected', (e) => {
  loadScripts({
    analytics: e.detail.analyticsAllowed,
    marketing: e.detail.marketingAllowed,
    preferences: e.detail.preferencesAllowed,
    saleOfData: e.detail.saleOfDataAllowed,
  });
});